
<div class="user-view">
  <page-header title="User">
    <template #actions>
      <icon-button
        icon="arrow_back"
        tooltip="Back to Users"
        @click="$router.push('/admin')"
      />
    </template>
  </page-header>

  <section v-if="loaded">
    <div class="user-info">
      <div><b>User ID:</b> {{ userId }}</div>
      <div><b>Email:</b> {{ user.email }}</div>
      <div><b>Display Name:</b> {{ user.displayName }}</div>
      <div><b>Role:</b> {{ user.role }}</div>

      <div v-if="user.subscription">
        <b>Subscription Type:</b> {{ user.subscription.type }}
      </div>

      <div v-if="user.subscription">
        <b>Subscription Platform:</b> {{ user.subscription.platform }}
      </div>

      <div><b>Login Method:</b> {{ user.providers.map((provider) => provider.providerId === 'password' ? 'email' : provider.providerId.replace('.com', '')).join(', ') }}</div>

      <br />
      <div><b>Created At:</b> {{ $filters.datetime(user.createdAt) }}</div>
      <div><b>Last Sign In:</b> {{ $filters.datetime(user.lastSignIn) }}</div>
    </div>

    <div class="links">
      <external-link v-if="user.customerId" :href="`https://dashboard.stripe.com/customers/${user.customerId}`">
        Stripe Customer
      </external-link>
    </div>

    <form class="change-email" @submit.prevent="changeEmail">
      <align small-gap>
        <text-input
          v-model="newEmail"
          type="email"
          label="New Email"
        />

        <btn
          :loading="changingEmail"
          :disabled="!newEmail"
          type="submit"
        >
          Change Email
        </btn>
      </align>
    </form>

    <form v-if="!isPsaCollectorsClubMember" class="combine-psa-membership" @submit.prevent="combinePsaMembership">
      <align small-gap>
        <text-input
          v-model="psaMembershipEmail"
          type="email"
          label="PSA Membership Email"
        />

        <btn
          :loading="combiningPsaMembership"
          type="submit"
          :disabled="!psaMembershipEmail"
        >
          Combine PSA Membership
        </btn>
      </align>
    </form>

    <form class="add-membership" @submit.prevent="addMembership">
      <align small-gap>
        <text-input
          v-model="stripeCustomerId"
          type="text"
          label="Stripe Customer ID"
        />

        <btn
          :loading="addingMembership"
          :disabled="!stripeCustomerId || !stripeMembershipSource"
          type="submit"
        >
          Add Membership
        </btn>

        <div class="membership-source">
          <select-input
            v-model="stripeMembershipSource"
            label="Source"
            :options="stripeMembershipSourceOptions"
            align="right"
          />
        </div>
      </align>
    </form>

    <div>
      <p><b>Number of Collection Cards:</b> {{ user.numberOfCollectionCards }}</p>

      <btn
        v-if="user.numberOfCollectionCards > 0"
        kind="secondary"
        :loading="cleaningUpCollectionCards"
        @click="cleanUpCollectionCards"
      >
        Clean Up Collection Cards
      </btn>
    </div>

    <br /><br />

    <p>
      <btn
        kind="error"
        :loading="deletingUser"
        @click="deleteUser"
      >
        Delete User
      </btn>
    </p>

    <div v-if="user.rateLimits && user.rateLimits.length" class="rate-limits">
      <h3>Rate Limits</h3>

      <div
        v-for="limit in user.rateLimits"
        :key="limit.endpoint"
        class="rate-limit-row"
      >
        <div class="rate-limit-endpoint">
          {{ limit.endpoint }}
        </div>
        <div>Minute: {{ limit.minuteCount }} / {{ limit.perMinute }}</div>
        <div>Day: {{ limit.dayCount }} / {{ limit.perDay }}</div>
        <div v-if="limit.lastRequest">
          Last request: {{ $filters.datetime(limit.lastRequest) }}
        </div>
      </div>
    </div>
  </section>

  <spinner v-else />
</div>
